import React, { useCallback, useEffect, useMemo, useState } from 'react'
import PropTypes from 'prop-types'
import { Box, Flex } from '@rebass/grid'
import { useTheme } from 'styled-components'
import { TbMessageChatbot } from 'react-icons/tb'
import { IoArrowUpCircleOutline } from 'react-icons/io5'
import Text from '../../atoms/Text'
import Button from '../../atoms/Button'
import Tooltip from '../../atoms/Tooltip'

const LOCAL_STORAGE_KEY_REFILL_TOOLTIP_OPENED = 'REFILL_QUOTA_TOOLTIP_OPENED'
const LOCAL_STORAGE_KEY_TOP_UP_TOOLTIP_OPENED = 'TOP_UP_TOOLTIP_OPENED'

const MessageQuotaBox = ({ quota, remaining, onClickTopUp, username }) => {
  const [refillTooltipOpen, setRefillTooltipOpen] = useState(false)
  const [topUpTooltipOpen, setTopUpTooltipOpen] = useState(false)
  const theme = useTheme()

  const onCloseTopUpTooltip = useCallback(() => {
    setTopUpTooltipOpen(false)
    localStorage.setItem(`${username}_${LOCAL_STORAGE_KEY_TOP_UP_TOOLTIP_OPENED}`, true)
  }, [username])

  const onCloseRefillTooltip = useCallback(() => {
    setRefillTooltipOpen(false)
    localStorage.setItem(`${username}_${LOCAL_STORAGE_KEY_REFILL_TOOLTIP_OPENED}`, true)
  }, [username])

  useEffect(() => {
    if (remaining <= 0) {
      const topUpTooltipOpened = localStorage.getItem(`${username}_${LOCAL_STORAGE_KEY_TOP_UP_TOOLTIP_OPENED}`)
      if (!topUpTooltipOpened) {
        setTopUpTooltipOpen(true)
      }
      const refillTooltipOpened = localStorage.getItem(`${username}_${LOCAL_STORAGE_KEY_REFILL_TOOLTIP_OPENED}`)
      if (!refillTooltipOpened) {
        setRefillTooltipOpen(true)
      }
    }
  }, [remaining, username])

  return (
    <Flex alignItems="center">
      <TbMessageChatbot size={24} />
      <Text variant="body1">: </Text>
      <Box ml="0.4rem">
        <Text
          variant="h3"
          id="message_remaining_count"
          bold
          {...(remaining <= 0 ? {
            palette: 'error',
            className: 'blink',
          } : {})}
        >
          {remaining || 0}
        </Text>
        {remaining <= 0 && (
          <Tooltip
            place="left-start"
            anchorId="message_remaining_count"
            open={refillTooltipOpen}
          >
            <Text palette="white">放心！今晚會加返比你！</Text>
            <Button
              palette="grayscale"
              padding="0.25rem 0.5rem"
              onClick={onCloseRefillTooltip}
              style={{ marginTop: '0.25rem' }}
            >
              <Text palette="white" variant="body2">知道</Text>
            </Button>
          </Tooltip>
        )}
      </Box>
      {/* <Text
        variant="body1"
        style={{ marginLeft: '0.4rem' }}
      >
        {`/ ${quota || 0}`}
      </Text> */}
      <Button
        padding={0}
        variant="text"
        id="top_up_btn"
        onClick={onClickTopUp}
        style={{ marginLeft: '0.2rem' }}
      >
        <IoArrowUpCircleOutline size={24} />
      </Button>
      {remaining <= 0 && (
        <Tooltip
          place="bottom-end"
          color={theme.palette.secondary[2]}
          anchorId="top_up_btn"
          open={topUpTooltipOpen}
        >
          <Text palette="white">{'唔夠用？\n立即增值亦得！'}</Text>
          <Flex justifyContent="flex-end" mt={1}>
            <Button
              palette="grayscale"
              padding="0.25rem 0.5rem"
              onClick={onCloseTopUpTooltip}
            >
              <Text palette="white" variant="body2">知道</Text>
            </Button>
          </Flex>
        </Tooltip>
      )}
    </Flex>

  )
}

MessageQuotaBox.propTypes = {
  quota: PropTypes.number,
  remaining: PropTypes.number,
  onClickTopUp: PropTypes.func,
  username: PropTypes.string,
}

MessageQuotaBox.defaultProps = {
  quota: 0,
  remaining: 0,
  onClickTopUp: () => {},
  username: '',
}

export default MessageQuotaBox
